// frontend/src/hooks/useNationalIdLengthChecker.js

import { useEffect } from 'react'

/**
 * Controla la validez del campo cédula según su longitud.
 * @param {Object} editedMember - Objeto con los datos del formulario.
 * @param {Function} setIsNationalIdValid - Setter para cambiar el estado de validez.
 */
export function useNationalIdLengthChecker(editedMember, setIsNationalIdValid) {
  useEffect(() => {
    if (editedMember.nationalId && editedMember.nationalId.length === 11) {
      setIsNationalIdValid(false)
    } else {
      setIsNationalIdValid(true)
    }
  }, [editedMember.nationalId, setIsNationalIdValid])
}
